<template>
  <div class="kezako-page pa-6">
    <h2 class="mt-8 mb-4">Les dernières vidéos</h2>
    <v-slide-group class="buzz-carousel" show-arrows>
      <v-slide-item v-for="(video, idx) in buzzVideos" :key="idx">
        <div class="buzz-video-wrapper">
          <iframe
            v-if="video.type === 'youtube'"
            class="buzz-video"
            width="100%"
            height="100%"
            :src="`https://www.youtube.com/embed/${video.id}`"
            frameborder="0"
            allowfullscreen
            :allow="'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'"
            style="aspect-ratio: 16/9"
          ></iframe>
          <div v-else-if="video.type === 'dailymotion' && video.id">
            <div v-if="!video.playing" class="buzz-video buzz-video-placeholder" @click="playDailymotion(idx)">
              <img
                src="/static/images/doodles-dsfr/secondary/SprintingDoodle.png"
                alt="Logo Labricot"
                style="width: 100%; height: 100%; object-fit: contain; background: #fff; border-radius: 12px"
              />
              <div class="buzz-play-btn">▶</div>
            </div>
            <iframe
              v-else
              class="buzz-video"
              width="100%"
              height="100%"
              :src="`https://www.dailymotion.com/embed/video/${video.id}?autoplay=1`"
              frameborder="0"
              style="width: 100%; height: 100%; overflow: hidden; border: none"
              allowfullscreen
              title="Dailymotion Video Player"
              allow="web-share; autoplay"
            ></iframe>
          </div>
        </div>
      </v-slide-item>
    </v-slide-group>
    <div class="mt-8 pdf-viewer-container">
      <h2 class="mb-4">Panneau pédagogique à télécharger</h2>
      <iframe class="pdf-viewer" :src="pdfUrl" width="100%" height="600" frameborder="0" allowfullscreen></iframe>
      <div class="mt-2 text-right">
        <a :href="pdfUrl" download target="_blank">Télécharger le PDF</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KezakoPage",
  data() {
    return {
      buzzVideos: [
        { type: "youtube", id: "EdpKBd3dA4Y" },
        { type: "dailymotion", id: "x79l4un" },
        { type: "dailymotion", id: "x531y71" },
        { type: "dailymotion", id: "x5fum7q" },
        { type: "dailymotion", id: "x5fump0" },
        { type: "dailymotion", id: "x531l31" },
        { type: "dailymotion", id: "x9g6crg" },
      ].map((v) => ({ ...v, playing: false })),
      pdfUrl: "/static/documents/panneaux_a3_01_web_cle818d11.pdf",
    }
  },
  methods: {
    playDailymotion(idx) {
      this.buzzVideos = this.buzzVideos.map((v, i) => (i === idx ? { ...v, playing: true } : v))
    },
  },
}
</script>

<style scoped>
.kezako-page {
  max-width: 800px;
  margin: 0 auto;
}
.buzz-carousel {
  max-width: 900px;
  margin: 0 auto;
  padding-bottom: 1rem;
}
.buzz-video-wrapper {
  width: 340px;
  height: 200px;
  margin: 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.buzz-video {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  background: #000;
}
.buzz-video-placeholder {
  position: relative;
  cursor: pointer;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.buzz-play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 3rem;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.pdf-viewer-container {
  max-width: 900px;
  margin: 0 auto;
}
.pdf-viewer {
  border: 1px solid #eee;
  border-radius: 8px;
  background: #f9f9f9;
}
@media (max-width: 600px) {
  .buzz-video-wrapper {
    width: 90vw;
    height: 200px;
    margin: 0 4px;
  }
}
</style>

<!--
Pour corriger l'erreur CSP, il faut ajouter youtube.com et dailymotion.com à la directive frame-src dans la configuration Content Security Policy (CSP) de votre serveur (nginx, Django, etc.).
Exemple pour nginx.conf ou dans l'en-tête HTTP :
Content-Security-Policy: frame-src 'self' ma-cantine.crisp.help ma-cantine-metabase.cleverapps.io localhost:* 0.0.0.0:* 127.0.0.1:* www.ssa.gov ajax.googleapis.com https://cdn.jsdelivr.net https://www.youtube.com https://www.dailymotion.com;

Si vous utilisez Django, adaptez la variable CSP_FRAME_SRC dans settings.py :
CSP_FRAME_SRC = ("'self'", "ma-cantine.crisp.help", "ma-cantine-metabase.cleverapps.io", "localhost:*", "0.0.0.0:*", "127.0.0.1:*", "www.ssa.gov", "ajax.googleapis.com", "https://cdn.jsdelivr.net", "https://www.youtube.com", "https://www.dailymotion.com")

Après modification, redémarrez le serveur web pour appliquer la nouvelle politique CSP.
-->
